import { type ComponentProps, type PropsWithChildren, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

import { EMPTY_BOARD } from '~/constants/testIDs';

export type NullStateProps = ComponentProps<'div'> & {
  image?: ReactNode;
  title?: string;
  description?: string | ReactNode;
  testId?: string;
  /** @deprecated - use children */
  cta?: ReactNode;
};

export const NullState = ({
  className,
  description,
  image,
  testId,
  title,
  children,
  cta,
}: PropsWithChildren<NullStateProps>) => {
  return (
    <section
      data-testid={EMPTY_BOARD}
      className={cn(
        "relative flex h-full w-full flex-col items-center bg-[url('/assets/illustrations/swirl-grey-light.svg')] bg-cover bg-no-repeat px-8 pt-8 pb-24 text-center md:px-16 md:py-24 dark:bg-[url('/assets/illustrations/swirl-grey-dark.svg')]",
        className,
      )}
    >
      {image}

      <div className="mb-4 flex flex-col gap-4">
        <h1 className="font-medium text-20 text-grey-12 md:text-24" data-testid={testId}>
          {title}
        </h1>

        {!!description && <p className="text-14 text-grey-10">{description}</p>}
      </div>

      {cta}

      {children}
    </section>
  );
};
